export default {
  services: state => { return state.services },
  service: state => { return state.service },
  subservice: state => { return state.subservice },
  suppliers: state => { return state.suppliers },
  supplier: state => { return state.supplier },
  projects: state => { return state.projects },
  clients: state => { return state.clients },
}